import { axiosInstance } from "../services/AxiosInstance";

const API_URL = "/contactpersons";

export const getContactPersons = async (
  limit = 100,
  page = 1,
  search = "",
  timeout = 5000,
) => {
  try {
    const response = await axiosInstance.get(API_URL, {
      params: {
        limit,
        page,
        search,
      },
      timeout,
    });
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching contact persons", error);
    throw error;
  }
};

export const createContactPerson = async (contactPersonData) => {
  try {
    const response = await axiosInstance.post(API_URL, contactPersonData);
    return response.data;
  } catch (error) {
    console.error("Error adding contact person", error);
    throw error;
  }
};

export const updateContactPerson = async (
  contactPersonId,
  contactPersonData,
) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/${contactPersonId}`,
      contactPersonData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating contact person", error);
    throw error;
  }
};

export const deleteContactPerson = async (contactPersonId) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/${contactPersonId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting contact person", error);
    throw error;
  }
};

export const getContactPersonById = async (contactPersonId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${contactPersonId}`);
    return {
      data: response.data.data, // ← change this to match actual response
      status: response.status,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error fetching contact person details", error);
    throw error;
  }
};
